import {  } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import FeaturesSection from "./Features";
import { motion } from 'framer-motion';
import Footer from "../../Component/Fooder";

const Healthsoftware = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* <div className="p-8  bg-gradient-to-t from-[#78ffa5] to-[#03ab3b]   w-full"> */}
      <div className="p-8  bg-white   w-full mt-3">
        {/* <h1 className=" mt-3 font-bold  text-white text-center mb-4 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"></h1> */}
        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="px-6 mb-2 text-center text-[30px] font-bold text-gray-800 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"
        >
         HikeHealth GS – Healthcare Software Development
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Feature 1 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
            {/* <FaRegHospital className="text-blue-500 text-3xl mb-3" /> */}
            <h2 className="text-center font-bold">Revenue Cycle Management</h2>
            <p className="text-gray-600 text-xs mt-2">
            We offer comprehensive solutions to streamline your revenue cycle, ensuring faster reimbursements and optimized financial processes.
            </p>
            <div className="-mb-12">
              <button
                onClick={() => navigate('/Services/HealthSoftware/Revenuecyclemanagement')}
                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                Read More
              </button>
            </div>


          </div>

          {/* Feature 2 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
            {/* <FaShieldAlt className="text-green-500 text-4xl mb-2" /> */}
            <h2 className="text-lg font-bold"> Healthcare Analytics</h2>
            <p className="text-gray-600 text-xs mt-2">
            Leverage data-driven insights for decision-making, enabling smarter, evidence-based approaches to healthcare management.
            </p>
            <div className="-mb-12">
 
              <button onClick={() => navigate('/Services/HealthSoftware/HealthcareAnalytics')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>

          {/* Feature 3 */}
          {/* <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
          
            <h2 className="text-lg font-bold">Patient Flow Management</h2>
            <p className="text-gray-600 text-xs mt-2">
            Streamline operations for better patient experience and reduced wait
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/HealthSoftware/PatientFlowManagement')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div> */}
          {/* Feature 4 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Clinical Health Records</h2>
            <p className="text-gray-600 text-xs mt-2">
            Enhance clinical workflows with software solutions designed for effective patient record management and improved clinical outcomes.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/HealthSoftware/ClinicalHealthRecords')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 5 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Telemedicine Solutions</h2>
            <p className="text-gray-600 text-xs mt-2">
            Build secure and efficient telemedicine platforms that support remote consultations, enhancing access to care and improving patient experience.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/HealthSoftware/Telemedicine')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>
          {/* Feature 6 */}
          <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
            {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
            <h2 className="text-lg font-bold">Risk/Case Management</h2>
            <p className="text-gray-600 text-xs mt-2">
            Implement risk management solutions that focus on proactive intervention and improved case management for better patient outcomes.
            </p>
            <div className="-mb-12">

              <button onClick={() => navigate('/Services/HealthSoftware/CDS')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
            </div>
          </div>

         
        </div>


        <div><FeaturesSection /></div>
      </div>
      <Footer />
    </>
  );
};

export default Healthsoftware;
